// var config = require('config.js')
// var authHttp = require('http/authHttp.js')
// var abortAllRequest = require('./http/basicHttp.js').abortAllRequest
// var isAllRequestOver = require('./http/basicHttp.js').isAllRequestOver
// var api = require('api.js')
// var cryptoJS = require('crypto/crypto-js.js')
// var {version} = require('../version.js')
import config from './config'
import authHttp from './http/authHttp'
import authHttpWV from './http/authHttpWV'
import abortAllRequest from './http/basicHttp'
import log from './log'
import {
	isAllRequestOver
} from './http/basicHttp'
import api from './api'
import cryptoJS from './crypto/crypto-js'
import version from '../version'

import { setArmsUser } from './sdk/ali-arms-web'




var tokenTimes = 0
var interval = null
// 时间
const formatTime = date => {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()

	return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

const formatNumber = n => {
	n = n.toString()
	return n[1] ? n : '0' + n
}

// const ProtoDate = Date
// Date = function (str) {
//   if (typeof str === 'string') {
//     return new ProtoDate(str.replace(/-/g, '/').replace(/\./g, '/'))
//   } else {
//     return new ProtoDate(...arguments)
//   }
// }

// Date.now = function () {
//   return ProtoDate.now()
// }

// ProtoDate.prototype.Format = function (formatStr) {
//   return formatDate(this, formatStr)
// }

//var time2 = new Date().Format("yyyy-MM-dd HH:mm:ss"); 

const changeTime = (dateOld, fmt) => {
	return formatDate(new Date(dateOld.replace(/(\+\d{2})(\d{2})$/, "$1:$2")), fmt);
}
const forWeek = (date) => {
	var weekDay = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]
	return weekDay[date.getDay()]
}
// const formatDate = (dateInst, fmt) => {
// 	if(!dateInst){
// 		return ''
// 	}
// 	if(typeof dateInst === 'string'){
// 		dateInst = dateInst.replace(/-/g, '/')
// 		dateInst = new Date(dateInst)
// 	}
// 	var o = {
// 		"M+": dateInst.getMonth() + 1, //月份 
// 		"d+": dateInst.getDate(), //日 
// 		"h+": dateInst.getHours(), //小时 
// 		"m+": dateInst.getMinutes(), //分 
// 		"s+": dateInst.getSeconds(), //秒 
// 		"q+": Math.floor((dateInst.getMonth() + 3) / 3), //季度 
// 		"S": dateInst.getMilliseconds() //毫秒 
// 	};
// 	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (dateInst.getFullYear() + "").substr(4 - RegExp.$1.length));
// 	for (var k in o)
// 		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[
// 			k]).substr(("" + o[k]).length)));
// 	return fmt;
// 	// return dateInst.Format(fmt)
// }


const formatDate = (date, fmt) => {
	if(typeof date === 'string'){
		date = date.replace(/-/g, '/')
		date = new Date(date)
	}
	const opt = {
		'y+': date.getFullYear().toString(), // 年
		'M+': (date.getMonth() + 1).toString(), // 月
		'd+': date.getDate().toString(), // 日
		'h+': date.getHours().toString(), // 时
		'm+': date.getMinutes().toString(), // 分
		's+': date.getSeconds().toString() // 秒
	}
	for (const k in opt) {
		const ret = new RegExp('(' + k + ')').exec(fmt)
		if (ret) {
			if (/(y+)/.test(k)) {
				fmt = fmt.replace(ret[1], opt[k].substring(4 - ret[1].length))
			} else {
				fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
			}
		}
	}
	return fmt
}

// 数字变汉字
function sectionToChinese(section) {
	section = parseInt(section)
	var chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
	var chnUnitSection = ["", "万", "亿", "万亿", "亿亿"];
	var chnUnitChar = ["", "十", "百", "千"];
	var strIns = '',
		chnStr = '';
	var unitPos = 0;
	var zero = true;
	while (section > 0) {
		var v = section % 10;
		if (v === 0) {
			if (!zero) {
				zero = true;
				chnStr = chnNumChar[v] + chnStr;
			}
		} else {
			zero = false;
			strIns = chnNumChar[v];
			strIns += chnUnitChar[unitPos];
			chnStr = strIns + chnStr;
		}
		unitPos++;
		section = Math.floor(section / 10);
	}
	return chnStr;
}

function getAccessToken(cb, fail_cb) {
	var params = {}
	params.grant_type = 'client_credential';
	params.appid = config.appId;
	params.secret = config.appKey;
	uni.request({
		url: config.weixinApi.getaccesstoken,
		data: params,
		method: 'GET',
		// header: {'content-type': 'application/json'},
		success: function(res) {
			uni.stopPullDownRefresh()
			typeof cb == 'function' && cb(res)
		},
		fail: function() {
			uni.stopPullDownRefresh()
			typeof fail_cb == 'function' && fail_cb()
		}
	})
}

// 获取客户端系统信息
function getSystemInfoSync() {
	var resInfo = uni.getSystemInfo()
	var res = uni.getSystemInfoSync()
	var systemInfo = {}
	try {
		systemInfo = {
			model: res.model,
			pixelRatio: res.pixelRatio,
			windowWidth: res.windowWidth,
			windowHeight: res.windowHeight,
			language: res.language,
			version: res.version,
			platform: res.platform,
			system: res.system,
			sysVersion: null
		}
		// 当前设备是否是平板通过计算设备显示的 PPI 值来计算，
		// 如 Apple New iPad 9.7英寸 2048x1536分辨率的 PPI 为 264，手机 5.3英寸 1280x720分辨率的 PPI 为 277
		let trimmedSystem = systemInfo.system.trim()
		let lastSpaceIdx = trimmedSystem.lastIndexOf(' ')
		if (lastSpaceIdx > 0) {
			systemInfo.system = trimmedSystem.substr(0, lastSpaceIdx)
			systemInfo.sysVersion = trimmedSystem.substr(lastSpaceIdx + 1)
		}

	} catch (e) {

	}
	var loginLog = {
		City: null, // 登录所在城市（需要请求用户授权获取手机定位）
		Province: null, // 登录所在省份（需要请求用户授权获取手机定位）
		Country: null, // 登录所在国家（需要请求用户授权获取手机定位）
		Language: null, // 浏览的语言风格 
		ThirdAppType: 1, // 第三方登录凭证类型（剧汇王朝用户登录时为空） = ['微信小程序' = 1, '其他' = 999], 使用数值，避免变更名称后出错
		SourceType: '小程序', // 登陆渠道 = ['Web', '小程序', 'App', '微信公众号', '其它']
		DeviceType: 'CellPhone', // 登录设备类型 = ['PC', 'Pad', 'CellPhone']
		Sysetm: null, // 客户机系统类型 
		SysVersion: null, // 客户机系统版本 
		Platform: null, // 产品寄宿的平台 
		PFMVersion: null, // 产品寄宿的平台的版本 
		ProductVersion: '0.0.1.1', // 产品版本与POMS版本一样
	}
	loginLog.Sysetm = systemInfo.system || null // 操作系统，如 iOS, Android
	loginLog.SysVersion = systemInfo.sysVersion || null // 操作系统，如 iOS 的 10.0.1，Android 的 5.0
	// loginLog.Platform = (systemInfo.platform == 'android' ? 'WeChat' : systemInfo.platform) // 小程序客户端平台名称（小程序开发工具为 devtools，手机微信客户端为）
	loginLog.Platform = 'WeChat'
	loginLog.PFMVersion = systemInfo.version || null // 微信版本号
	loginLog.Language = systemInfo.language || 'zh_CN'
	loginLog.ProductVersion = version || '0.0.1.1'
	return {
		systemInfo: systemInfo,
		loginLog: loginLog
	}
}

function getProgramEnv(){
	let systemInfo = getSystemInfoSync()
	let envStr = 0 // (0, “未知”),(1, “服务器后端埋点，即 API 埋点”),(2, “PC，桌面”),(3, “安卓APP”),(4, “苹果APP”),(5, “微信公众号等 H5”),(6, “微信小程序”),(7, “H5”),(12, “抖音小程序”),












	envStr = 7
	if(isWeiXin()){
		envStr = 5
	}

	return envStr
}

function requestData(url, params, method) {
	return new Promise((resolve, reject) => {
		if (typeof method === 'undefined') {
			method = 'POST'
		}
		if (method.toUpperCase() === 'GET') {
			authHttp.get(url, params).then(res => {
				resolve(res.data)
			}).catch(res => {
				// typeof fail_cb == 'function' && fail_cb(res) // 没有统一的错误处理时再调用业务的错误处理
				res = errorResFunction(res,url,params)
				reject(res)
			})
		} else {
			authHttp.post(url, params).then(res => {
				resolve(res.data)
			}).catch(res => {
				// typeof fail_cb == 'function' && fail_cb(res) // 没有统一的错误处理时再调用业务的错误处理
				res = errorResFunction(res,url,params)
				reject(res)
			})
		}
	})
}



function errorResFunction(res,url,params) {
	log.error('请求错误',url,params,res)
	if (res.errMsg && res.errMsg.indexOf('request:fail') >= 0) {
		if (res.data) res.data.message = '请求超时'
		return res
	} else {
		let status = res.statusCode
		if (status === 200 && res.data && res.data.succeeded === false && res.data.code > 0 && fail_cb && typeof fail_cb ==
			'function') {
			if (res.data.code === 523 || res.data.code === 520) {
				res.data.message = '今日勾搭已达上限，明日再来吧！'
			}
			if (res.data.code === 461 || res.data.code === 462 || res.data.code === 463) {
				res.data.message = '该巡演已下线！'
			}
			return res
		}
		switch (status) {
			// case 462:
			// case 463:
			// case 464:
			// case 465: // 短信验证码
			//   break
			// case 522: // 微信用户尚未注册
			//   break
			// case 526: // 微信用户登录POMS失败
			//   break
			case 460: // 入参校验失败
				// 微信手机注册时的错误460不需要提示
				let data_message = res.data
				if (res.data && res.data instanceof Array) {
					data_message = res.data.join(',')
				}
				uni.showToast({
					title: data_message,
					icon: 'none',
					duration: 3000
				})
				break
			case 401:
				// 重新获取token
				break
			default:
				// 先统一话消息提示
				if (res && res.data) {
					if (Array.isArray(res.data)) {
						if (res.data.length > 0) {
							let message = ''
							res.data.forEach(item => {
								if (item) {
									if (message) {
										message += '\n' + item
									} else {
										message = item
									}
								}
							})
							res.message = message
						}
					} else if (typeof(res.data) === 'string') {
						res.message = res.data
					}
					if (res.data.Message) {
						res.message = res.data.Message
					}
					if (res.data.Messages) {
						res.message = res.data.Messages[0]
					}
				} else {
					res = {}
				}
				// 如果业务已经定义了错误提示，则使用业务的处理
				return res
		}
	}
	return res
}


// 获取数据
function postData(url, params, method, cb, fail_cb) {
	let that = this
	if (typeof method === 'undefined') {
		method = 'POST'
	}
	if (method.toUpperCase() === 'GET') {
		authHttp.get(url, params).then(res => {
			if (that.setData) {
				// that.netTimeOut = false
				that.setData({
					netTimeOut: false // 不超时
				})
			} else {
				that.netTimeOut = false
			}
			typeof cb == 'function' && cb(res)
		}).catch(res => {
			// typeof fail_cb == 'function' && fail_cb(res) // 没有统一的错误处理时再调用业务的错误处理
			errorFunction(that, res, fail_cb)
		})
	} else {
		authHttp.post(url, params).then(res => {
			if (that.setData) {
				that.setData({
					netTimeOut: false // 不超时
				})
			} else {
				that.netTimeOut = false
			}
			typeof cb == 'function' && cb(res)
		}).catch(res => {
			// typeof fail_cb == 'function' && fail_cb(res) // 没有统一的错误处理时再调用业务的错误处理
			// debugger
			errorFunction(that, res, fail_cb)
		})
	}
}

function postDataWV(url, params,access_token,clientId, method, cb, fail_cb) {
	let that = this
	if (typeof method === 'undefined') {
		method = 'POST'
	}
	if (method.toUpperCase() === 'GET') {
		authHttpWV.get(url, params,access_token,clientId).then(res => {
			if (that.setData) {
				// that.netTimeOut = false
				that.setData({
					netTimeOut: false // 不超时
				})
			} else {
				that.netTimeOut = false
			}
			typeof cb == 'function' && cb(res)
		}).catch(res => {
			// typeof fail_cb == 'function' && fail_cb(res) // 没有统一的错误处理时再调用业务的错误处理
			errorFunction(that, res, fail_cb,url,params)
		})
	} else {
		authHttpWV.post(url, params,access_token,clientId).then(res => {
			if (that.setData) {
				that.setData({
					netTimeOut: false // 不超时
				})
			} else {
				that.netTimeOut = false
			}
			typeof cb == 'function' && cb(res)
		}).catch(res => {
			// typeof fail_cb == 'function' && fail_cb(res) // 没有统一的错误处理时再调用业务的错误处理
			// debugger
			errorFunction(that, res, fail_cb,url,params)
		})
	}
}

// 请求错误处理
function errorFunction(that, res, fail_cb,url,params) {
	log.error('请求错误',url,params,res)
	if (res.errMsg && res.errMsg.indexOf('abort') >= 0) {
		return
	}
	if (res.errMsg && res.errMsg.indexOf('request:fail') >= 0) {
		let errmsg = '网络异常，请检查网络'
		if(res.errMsg.indexOf('timeout') >= 0) errmsg = "服务器繁忙，请稍后再试"
		uni.showToast({
			title: errmsg,
			icon: 'none',
			image: config.defaultImg.iconCry,
			duration: 1500
		})
		that.netTimeOut = true
		if (fail_cb && typeof fail_cb == 'function') {
			if (res.data) {
				res.data.message = errmsg
			} else {
				res.data = {
					message: errmsg
				}
			}
			fail_cb(res)
			return
		}
	} else {
		let status = res.statusCode
		if (status === 200 && res.data && res.data.succeeded === false && res.data.code > 0 && fail_cb && typeof fail_cb ==
			'function') {
			if (res.data.code === 523 || res.data.code === 520) {
				res.data.message = '今日勾搭已达上限，明日再来吧！'
			}
			if (res.data.code === 461 || res.data.code === 462 || res.data.code === 463) {
				res.data.message = '该巡演已下线！'
			}
			fail_cb(res)
			return
		}
		if (that.data && that.data.我要自己提示 && fail_cb && typeof fail_cb == 'function') {
			// 先统一话消息提示
			if (res && res.data) {
				if (Array.isArray(res.data)) {
					if (res.data.length > 0) {
						let message = ''
						res.data.forEach(item => {
							if (item) {
								if (message) {
									message += '\n' + item
								} else {
									message = item
								}
							}
						})
						res.message = message
					}
				} else if (typeof(res.data) === 'string') {
					res.message = res.data
				}
				if (res.data.Message) {
					res.message = res.data.Message
				}
				if (res.data.Messages) {
					res.message = res.data.Messages[0]
				}
			} else {
				res.message = ''
			}
			that.data.我要自己提示 = false
			fail_cb(res)
			return
		}
		switch (status) {
			// case 462:
			// case 463:
			// case 464:
			// case 465: // 短信验证码
			//   break
			// case 522: // 微信用户尚未注册
			//   break
			// case 526: // 微信用户登录POMS失败
			//   break
			case 460: // 入参校验失败
				// 微信手机注册时的错误460不需要提示
				let data_message = res.data
				if (res.data && res.data instanceof Array) {
					data_message = res.data.join(',')
				}
				uni.showToast({
					title: data_message,
					icon: 'none',
					duration: 3000
				})
				break
				// case 521: // 请求微信API换取微信用户Session失败
				//   uni.showToast({
				//     title: '微信出错了',
				//     icon: 'none',
				//     duration: 3000
				//   })refreshToken
				//   break
			case 401:
				// 重新获取token
				// uni.showToast({ title: '未授权！理论上是不可能的', icon: 'none', duration: 3000 })
				// 更新token
				if (!that.tokenRefreshing) {
					that.tokenRefreshing = true // 立即设置一个标志，避免并发太快时触发了多次  
					refreshToken(that)
				} else {
					console.error('401 错误已经触发了刷新令牌动作，不再重复执行')
				}
				break
			default:
				// 先统一话消息提示
				console.log('============xxxxxxx=>',res)
				if (res && res.data) {
					if (Array.isArray(res.data)) {
						if (res.data.length > 0) {
							let message = ''
							res.data.forEach(item => {
								if (item) {
									if (message) {
										message += '\n' + item
									} else {
										message = item
									}
								}
							})
							res.message = message
						}
					} else if (typeof(res.data) === 'string') {
						res.message = res.data
					}
					if (res.data.Message) {
						res.message = res.data.Message
					}
					if (res.data.Messages) {
						res.message = res.data.Messages[0]
					}
					if (res.data.msg) {
						res.data.message = res.data.msg
						res.message = res.data.msg
						if(res.data.msg === '触发限流') res.data.message = '人数过多,请稍后再试'
					}
				} else {
					res = {}
				}
				// 如果业务已经定义了错误提示，则使用业务的处理
				if (fail_cb && typeof fail_cb == 'function') {
					fail_cb(res)
					return
				}
				uni.showToast({
					title: res.message,
					icon: 'none',
					duration: 3000
				})
		}
	}
}

// 重新获取token (主要是在请求数据发生401错误时调用)
function refreshToken(that) {
	that.tokenRefreshing = true // 立即设置一个标志，避免并发太快时触发了多次
	// 重新登录，刷新Token。
	let innerRequestToken = function() {
		tokenTimes++
		console.log('tokenTimes==========>',tokenTimes,config.refreshTokenTimes)
		if (tokenTimes <= config.refreshTokenTimes) {
			// H5不支持login//////////////
			let url = api.userOauthTokenH5
			let params = {
				// LoginLogInfo: getSystemInfoSync().loginLog // 添加登录日志需要的额外信息
				grant_type: 'refresh_token',
				refresh_token: authHttp.getRefreshToken()
			}
			authHttp.get(url, params).then(res_a => {
				parseGetWeChatUserByCodeResult(that, res_a, undefined, innerRequestToken)
			}).catch(res => {
				parseGetWeChatUserByCodeResult(that, undefined, res, innerRequestToken)
			})
		} else {
			// 重新请求授权多次后仍然失败
			that.tokenRefreshing = false
			tokenTimes = 0
			commonViewTap('/pages/login/login')
		}
	}
	// 开启触发请求
	innerRequestToken()
}
// 重新获取token (主要是在请求数据发生401错误时调用)
function refreshToken_bak(that) {
	that.tokenRefreshing = true // 立即设置一个标志，避免并发太快时触发了多次
	// 重新登录，刷新Token。
	let innerRequestToken = function() {
		tokenTimes++
		if (tokenTimes <= config.refreshTokenTimes) {
			// H5不支持login//////////////
			uni.login({
				success: res_login => {
					// 发送 res.code 到后台换取 openId, sessionKey, unionId
					let url = api.getWeChatUserByCode
					let params = {
						Code: res_login.code,
						LoginLogInfo: getSystemInfoSync().loginLog // 添加登录日志需要的额外信息
					}
					authHttp.post(url, params).then(res_a => {
						parseGetWeChatUserByCodeResult(that, res_a, undefined, innerRequestToken)
					}).catch(res => {
						parseGetWeChatUserByCodeResult(that, undefined, res, innerRequestToken)
					})
				},
				fail: errInfo => {
					// 微信授权失败
					setTimeout(function() {
						innerRequestToken()
					}, 3000)
				}
			})
		} else {
			// 重新请求授权多次后仍然失败
			that.tokenRefreshing = false
			tokenTimes = 0
			commonViewTap('/pages/login/login')
		}
	}
	// 开启触发请求
	innerRequestToken()
}

function parseGetWeChatUserByCodeResult(that, okResult, errResult, innerRequestToken) {
	if (okResult && okResult.succeeded) {
		let okRespData = okResult.data
		uni.setStorageSync('cipher_key', okRespData.secret)
		uni.setStorageSync('temp_token', okRespData.token)
	}
	if (okResult == undefined || (!okResult.data.access_token)) {
		let res = errResult
		let errMsg = ''
		let statusCode = 0
		if (res) {
			errMsg = res.errMsg
			statusCode = res.statusCode
		} else {
			if (!okResult.succeeded) {
				errMsg = okResult.message
				statusCode = okResult.code
			} else if (!okResult.data.succeeded) {
				errMsg = okResult.data.errMsg
				statusCode = okResult.data.statusCode
			}
		}

		if (statusCode === 522) { // 未注册了，无法再获取直接跳出
			commonViewTap('/pages/index/index', 3) // 改版首页后需要去起始页码验证登录
			return false
		}
		// 调用业务系统的认证授权服务，本次请求授权失败，则再次发起
		// setTimeout(function() {
		// 	innerRequestToken()
		// }, 3000)
		innerRequestToken()
	} else {
		let okRespData = okResult
		loginSucceed(that, okRespData)
	}
}

function loginSucceed(that, res_a) {
	if (res_a.data.access_token) {
		uni.setStorageSync('access_token', res_a.data.access_token)
		uni.setStorageSync('refresh_token', res_a.data.refresh_token)
	}
	that.tokenRefreshing = false
	tokenTimes = 0
	// 设置ARMS用户ID
	try {
		let iyanyiUser = uni.getStorageSync('iyanyiUser')
		let clientId = uni.getStorageSync('clientId')
		if (iyanyiUser && iyanyiUser.Id) {
			setArmsUser(clientId+'-'+iyanyiUser.Id)
		}
	} catch (e) {}
	// commonViewTap('/pages/entityList/entityList?notAutoEnter=true', 3) // 出现401错误重新申请授权后跳转到首次加载小程序的经营体页面
	// 出现401错误重新申请授权后重新加载当前页面
	reloadCurrentPages(that)
	// 检查并强制更新小程序（会弹出提示用户）
	checkAndForceUpdate(res_a.data)
}
// 接受 GetAndLogin 的结果，并判断是否强制更新
function checkAndForceUpdate(res) {
	if (res.ClientUpdateEnforced) {
		detectionUpdata()
	}
}

//重新加载当前页面
function reloadCurrentPages(that) {
	let pages = getCurrentPages();
	let page = pages[pages.length - 1];
	let currPage = null;
	let options = page.options || page.$route.query;
	if (pages.length) {
		currPage = '/' + pages[pages.length - 1].route;
		if (Object.keys(options).length > 0) {
			currPage = currPage + '?'
			for (let option in options) {
				currPage = currPage + option + '=' + options[option] + '&'
			}
		}
	}
	// 判断是否tabBar页面
	if (currPage.search(/(pages\/main\/main)|(pages\/ticketWallet\/ticketWallet)|(pages\/my\/my)/g) === -1) {
		if(currPage.indexOf('/webView/')>0){
			page.initShow()
		} else {
			commonViewTap(currPage, 1)
		}
	} else {
		// configAll.util.commonViewTap(currPage, 2)
		// h5和小程序方法不一样
		if (that.$router) {
			that.$router.go(0)
		} else {
			page.onLoad()
			page.onShow()
		}
	}
}

//检测并更新版本
function detectionUpdata() {
	const updateManager = uni.getUpdateManager()
	updateManager.onCheckForUpdate(function(res) {
		// 请求完新版本信息的回调
		if (res.hasUpdate) {
			updateManager.onUpdateReady(function() {
				updateManager.applyUpdate()
				uni.showLoading({
					title: '版本更新中...',
				})
			})
			updateManager.onUpdateFailed(function() {
				// 新的版本下载失败
				uni.showModal({
					title: '新版本已经上线',
					content: '请您删除当前小程序，重新搜索打开',
					showCancel: false,
					confirmText: '知道了'
				})
			})

		}
	})
}

// 获取数据列表
function postDataList(url, params, method, cb, fail_cb) {
	var that = this
	postData.call(that, url, params, method,
		function(resAll) { // 成功
			let res = resAll.data
			if (that.setData) { // 微信小程序内
				that.setData({
					dataList: that.data.dataList.concat(res.data.DataRows || res.data),
					pageIndex: res.data.CurrentPageIndex
				})
				// 当前页码等于总页码则没有更多了
				if (res.data.PageCount === res.data.CurrentPageIndex) {
					that.setData({
						hasMore: false,
					})
				} else {
					that.setData({
						hasMore: true,
					})
				}
			} else {
				that.dataList = that.dataList.concat(res.data.DataRows || res.data)
				that.pageIndex = res.data.CurrentPageIndex
				// 当前页码等于总页码则没有更多了
				if (res.data.PageCount === res.data.CurrentPageIndex) {
					that.hasMore = false
				} else {
					that.hasMore = true
				}
			}

			typeof cb == 'function' && cb(res)
		},
		function(res) { // 失败
			if (typeof fail_cb == 'function') {
				fail_cb(res)
			}
		},
	)
}

// 上传图片
function uploadImg(url, params, cb, fail_cb) {
	var that = this;
	uni.chooseImage({
		count: 1, // 默认9
		sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
		sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
		success: function(res) {
			var tempFilePaths = res.tempFilePaths;
			// var header = {
			//   'content-type': 'multipart/form-data'
			// }
			var access_token = uni.getStorageSync('access_token')
			var header = {
				"Authorization": access_token.startsWith('Bearer ') ? access_token : 'Bearer ' + access_token
			}
			uni.uploadFile({
				url: url,
				filePath: tempFilePaths[0],
				name: 'IsThumbnail',
				header: header,
				formData: params,
				success: function(res) {
					typeof cb == 'function' && cb(res)
				}
			})
		}
	})
}

// 页面分享操作 app.util.commonShareAppMessage()
function commonShareAppMessage(params) {
	if (typeof params === 'undefined') {
		params = config.ShareMessage
	}
	return params
}

// 页面跳转操作 e:点击dom属性,t:跳转类型 default:navigate,ChannelId:是否渠道商来源 后续再加   
// <text catchtap="doViewTap" data-url="/pages/login/login?title=navigate">跳转</text>
// var data = e.currentTarget.dataset;
// var url = data.url
// app.util.commonViewTap(url)
// success fail complete
function commonViewTap(url, t) {
	// debugger
	//拼接渠道商id
	let appt=getApp()
	let ChannelId=appt.globalData.ChannelId
	if(ChannelId){
		let arr = url.split('?')
		if(arr[0]==='/pages/my/my'){
			arr[0]='/pagespacka/channel/my'
			t=3
		}
		if(arr.length>1){
			let options = arr[1].split('&')
			let obj = {}
			options.forEach(item=>{
				let a = item.split('=')
				obj[a[0]]=a[1]
			})
			obj.ChannelId = ChannelId
			options=[]
			for(let i in obj){
				options.push(i+'='+obj[i])
			}
			url=arr[0]+'?'+options.join('&')
		}else{
			url=arr[0]+'?ChannelId='+ChannelId
		}
	}

	switch (t) {
		case 1: // 关闭当前页面，跳转到应用内的某个页面。
			uni.redirectTo({
				url: url
			})
			break
		case 2: // 跳转到 tabBar 页面，并关闭其他所有非 tabBar 页面 需在 app.json 的 tabBar 字段定义的页面  路径后不能带参数
			uni.switchTab({
				url: url
			})
			break
		case 3: // 关闭所有页面，打开到应用内的某个页面。
			uni.reLaunch({
				url: url
			})
			break
		case 99: // 关闭当前页面，返回上一页面或多级页面。可通过 getCurrentPages()) 获取当前的页面栈，决定需要返回几层。
			uni.navigateBack({
				delta: 1
			})
			break
		default: //保留当前页面，跳转到应用内的某个页面，使用uni.navigateBack可以返回到原页面
			uni.navigateTo({
				url: url
			})
	}

}

// 通用校验规则
const validateRules = {
	isCountryPhoneNumber(code, phone) {
		let result = true
		if(!phone) result = false
		const phoneRegex = /^(\+?0?86\-?)?1[3456789]\d{9}$/;
		if((!code || code === '+86') && phone){
			result = phoneRegex.test(phone)
		}
		
		return result
	},
	// 校验11位手机号
	phoneNumber(value) {
		if (value) {
			if (/^[1][3,4,5,6,7,8,9][0-9]{9}$/g.test(value)) {
				return true
			} else {
				return false
			}
		} else {
			return false
		}
	},
	telNumber(value) {
		if (value) {
			if (/^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/g.test(value)) {
				return true
			} else {
				return false
			}
		} else {
			return false
		}
	},
	checkPhoneNew(value) {
		if (value) {
			if (value.length <= 20) {
				return true
			} else {
				return false
			}
		} else {
			return false
		}
	},
	// 校验邮箱名称允许汉字、字母、数字，域名只允许英文域名
	mailString(value) {
		if (value) {
			if (/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/g.test(value)) {
				return true
			} else {
				return false
			}
		} else {
			return false
		}
	},
	// 函数参数必须是字符串，因为二代身份证号码是十八位，而在javascript中，十八位的数值会超出计算范围，造成不精确的结果，导致最后两位和计算的值不一致，从而该函数
	checkIDCard(idcode) {
		// 加权因子
    // var weight_factor = [7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2];
    // // 校验码
    // var check_code = ['1', '0', 'X' , '9', '8', '7', '6', '5', '4', '3', '2'];

    // var code = idcode + "";
    // var last = idcode[17];//最后一位

    // var seventeen = code.substring(0,17);

    // // ISO 7064:1983.MOD 11-2
    // // 判断最后一位校验码是否正确
    // var arr = seventeen.split("");
    // var len = arr.length;
    // var num = 0;
    // for(var i = 0; i < len; i++){
    //     num = num + arr[i] * weight_factor[i];
    // }
    
    // // 获取余数
    // var resisue = num%11;
    // var last_no = check_code[resisue];

    // 格式的正则
    // 正则思路
    /*
    第一位不可能是0
    第二位到第六位可以是0-9
    第七位到第十位是年份，所以七八位为19或者20
    十一位和十二位是月份，这两位是01-12之间的数值
    十三位和十四位是日期，是从01-31之间的数值
    十五，十六，十七都是数字0-9
    十八位可能是数字0-9，也可能是X
    */
		// var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
		// var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0-9]{2})([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
		var idcard_patter = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/;

    // 判断格式是否正确
    var format = idcard_patter.test(idcode);
    // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
    return format;
	},
}

// 自定义MessageToast操作
const messageToast = {
	show: function(message, time, iconType) {
		let that = this
		if (typeof time === "undefined") {
			time = 1500
		}
		if (typeof iconType === "undefined") {
			iconType = 1
		}
		that.setData({
			toastMsg: message,
			iconType: iconType
		})
		setTimeout(function() {
			that.setData({
				toastMsg: '',
				iconType: 1
			})
		}, time)
	}
}

function getPhoneNumberCodeString(phone) {
	let PhoneNumberString = phone ? phone.substring(0, 3) + '****' + phone.substring(7, 11) : '无'
	return PhoneNumberString
}

// 数字格式化
function toThousands(num) {
	var num = (num || 0).toString(),
		result = '',
		sof = '00'
		
	if(num.indexOf(',')>0){
		return num;
	}
	if (num.indexOf('.') > 0) {
		sof = num.split('.')[1].substring(0, 2)
		if (sof.length === 1) {
			sof = sof + '0'
		}
		if (sof.length === 0) {
			sof = sof + '00'
		}
		num = num.split('.')[0]
	}
	while (num.length > 3) {
		result = ',' + num.slice(-3) + result;
		num = num.slice(0, num.length - 3);
	}
	if (num) {
		result = num + result;
	}
	if (result.indexOf('-') === 0) {
		result = result.replace('-,', '-')
	}
	return result + '.' + sof;
}
// 处理相对路径url问题。为相对路径增加host头，如果是绝对路径则不需要再添加
function dealRelativeUrl(url, hostToAdd) {
	if (!url) {
		return ''
	}
	if (!hostToAdd) {
		return url
	}
	if (url.startsWith('http://') || url.startsWith('https://')) {
		return url
	}
	// 移除最后的/
	hostToAdd = (hostToAdd.substring(hostToAdd.length - 1) === '/') ? hostToAdd.substring(0, hostToAdd.length - 1) :
		hostToAdd;
	return hostToAdd + '/' + url
}

function getPrePage() {
	let pages = getCurrentPages()
	if (pages.length < 2) throw new Error("不存在前一页的Page")
	return pages[pages.length - 2]
}

function setPrePageData(data) {
	let pages = getCurrentPages()
	if(pages[pages.length - 2].setData){
		pages[pages.length - 2].setData(data)
	} else {
		for(var k in data){
			pages[pages.length - 2][k] = data[k]
		}
	}
}
// 显示地图地址位置
function viewMapAddress(args) {
	if (!args || args.latitude === undefined || args.longitude === undefined) {
		// 如果是空值，调用openLocation会报错。错误的坐标会定位地图会进行处理，定位到北京
		return
	}
	uni.openLocation({ //​使用微信内置地图查看位置。
		latitude: args.latitude, //要去的纬度-地址
		longitude: args.longitude, //要去的经度-地址
		name: args.name, // 位置名
		address: args.address, // 地址的详细说明
		success:function (e) {
			console.log('打开地图成功',e)
		},
		fail:function (e) {
			console.log('打开地图失败',e)
		}
	})
	//获取当前经纬度
	// uni.getLocation({
	//   //返回可以用于uni.openLocation的经纬度，官方提示bug: iOS 6.3.30 type 参数不生效，只会返回 wgs84 类型的坐标信息  
	//   type: 'wgs84',
	//   success: function (res) {
	//     uni.openLocation({//​使用微信内置地图查看位置。
	//       latitude: args.latitude,//要去的纬度-地址
	//       longitude: args.longitude,//要去的经度-地址
	//       name: args.name, // 位置名
	//       address: args.address // 地址的详细说明
	//     })
	//   }
	// })
}

/**
 * 构建可用的宣传片(视频)地址
 * 
 * @param respResData API返回的数据
 * @param url 上传的原始媒体文件 url
 * @param optionalUrl 转码后的媒体文件 url
 * @param mtJobId 媒体转码任务 ID
 */
function buildAvailableVideoUrl(respResData, url, optionalUrl, mtJobId) {
	let resData = {}
	// 初始化 url 相关数据
	if (respResData) {
		let targetProp = ''
		let stopCounter = 0
		for (let prop in respResData) {
			if (stopCounter >= 3) {
				break
			}
			if (respResData.hasOwnProperty(prop)) {
				targetProp = 'advideourl'
				if (prop.toLowerCase().endsWith(targetProp)) {
					stopCounter = stopCounter + 1
					resData.ADVideoUrl = respResData[prop]
					continue
				}
				targetProp = 'advideooptionalurl'
				if (prop.toLowerCase().endsWith(targetProp)) {
					stopCounter = stopCounter + 1
					resData.ADVideoOptionalUrl = respResData[prop]
					continue
				}
				targetProp = 'advideojobid'
				if (prop.toLowerCase().endsWith(targetProp)) {
					stopCounter = stopCounter + 1
					resData.ADVideoJobId = respResData[prop]
					continue
				}
			}
		}

		if (!url || url.trim().length === 0) {
			url = resData.ADVideoUrl
		}
		if (!optionalUrl || optionalUrl.trim().length === 0) {
			optionalUrl = resData.ADVideoOptionalUrl
		}
		if (!mtJobId || mtJobId.trim().length === 0) {
			mtJobId = resData.ADVideoJobId
		}
	}

	// 如果值不存在，则抛出异常
	if ((!url || url.trim().length == 0) && (!optionalUrl || optionalUrl.trim().length == 0)) {
		if (!resData.ADVideoUrl && !resData.ADVideoOptionalUrl) {
			let errorMessage = '请检查 API 返回的数据中是否含有字段 xxxADVideoUrl 和 xxxADVideoOptionalUrl，' +
				'或者将 xxxADVideoUrl，xxxADVideoOptionalUrl，以及 xxxJobId ' +
				'传给第 2 个参数，第 3 个参数，第 4 个参数'
			//throw new Error('请检查 API 返回的数据中是否含有字段 xxxADVideoUrl 和 xxxADVideoOptionalUrl，'
			//  + '或者将 xxxADVideoUrl，xxxADVideoOptionalUrl，以及 xxxJobId ' 
			//  + '传给第 2 个参数，第 3 个参数，第 4 个参数')
		}
	}

	let videoSrc = url || ''
	if (optionalUrl && optionalUrl.trim().length > 0) {
		// 如果 JobId 为空，则表示转码已完成（不管失败还是成功）
		if (!mtJobId || mtJobId.trim().length === 0) {
			// 去播放转码后的视频
			videoSrc = optionalUrl
		}
	}
	return videoSrc
}

// 根据坐标判断左滑右滑
function judgeTouchDirection(endX, endY, startX, startY) {
	let turn = ""
	if (endX - startX > 50 && Math.abs(endY - startY) < 50) {
		turn = 'right'
	} else if (endX - startX < -50 && Math.abs(endY - startY) < 50) {
		turn = 'left'
	}
	return turn
}

// 数组去重
function arrUniq(arr) {
	let temp = []
	for (let i = 0; i < arr.length; i++) {
		if (temp.indexOf(arr[i] == -1)) {
			temp.push(arr[i])
		}
	}
	return temp
}

// 对请求的URL及其参数对象进行 HMAC_SHA256 加密，后端会进行相应同样操作并校验请求是否被改动过
function cryptoParamObject(param) {
	try {
		var paramStr = JSON.stringify(param)
		param.cc = hmacSHA256Enc(str)
	} catch (e) {
	}
}
// 对请求的URL及其参数值进行 HMAC_SHA256 加密，后端会进行相应同样操作并校验请求是否被改动过
function cryptoParamValues(param) {
	try {
		var keyList = Object.keys(param)
		var str = ""
		for (var i = 0; i < keyList.length; i++) {
			str = str + (param[keyList[i]] || "").toString()
		}
		param.cc = hmacSHA256Enc(str)
	} catch (e) {
	}
}

function hmacSHA256Enc(message) {
	const hash = cryptoJS.HmacSHA256(message, config.encKey)
	return cryptoJS.enc.Base64.stringify(hash)
}

//通过id获取元素的布局位置和滚动位置
function getboundingClientRect(that, id) {
	return new Promise((resolve) => {
		that.$nextTick(() => {
			uni.createSelectorQuery().select(id).boundingClientRect().selectViewport().scrollOffset().exec((rect) => {
				resolve(rect)
			})
		})

	})
}
// 对象拷贝:连同原型和实例属性一起
function cpObject(obj) {
	if (obj === null) {
		return null
	} else {
		return Object.create(
			Object.getPrototypeOf(obj),
			Object.getOwnPropertyDescriptors(obj)
		)
	}
}

// 时间格式化
function formatDateTime(dateTime, type) {
	let newDateStr = dateTime.replace(/-/g, '/')
	let newDate = new Date(newDateStr)
	let year = newDate.getFullYear()
	let month = addZero(newDate.getMonth() + 1)
	let day = addZero(newDate.getDate())
	let weekDay = transWeekDay(newDate.getDay())
	let hour = addZero(newDate.getHours())
	let minute = addZero(newDate.getMinutes())
	let second = addZero(newDate.getSeconds())
	if (type === 1) {
		// 2019/08/30 15:20:39
		return ` ${year}/${month}/${day} ${hour}:${minute}:${second} `
	}
	if (type === 2) {
		// 2019/08/30
		return ` ${year}/${month}/${day} `
	}
	if (type === 3) {
		// 2019/08/30 周六 15:20:39
		return `${year}/${month}/${day} ${weekDay} ${hour}:${minute}`
	}
}
// 数字小于10加0
function addZero(val) {
	return val < 10 ? '0' + val : val
}
// 将weekday转换成星期几
function transWeekDay(e) {
	return ['周日', '周一', '周二', '周三', '周四', '周五', '周六'][e]
}

// 观察对象方法
const domWatch = function(domObj, callback) {
	return new domWatchClass(domObj, callback)
}
const domWatchClass = function(domObj, callback) {
	let domObserver = new MutationObserver(callback)
	let option = {
		'childList': true, // 子节点的变动
		'attributes': true, // 属性的变动
		'characterData': true // 节点内容或节点文本的变动
	}
	domObserver.observe(domObj, option)
	this.tempObj = domObserver
	this.stopWatch = function() {
		this.tempObj.disconnect()
	}
}

function isWeiXin() {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return true;
	} else {
		return false;
	}
}

function getQueryStringByName(url, name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
	var r = url.match(reg)
	if (r != null) return unescape(r[2]);
	return null;
}

function loadJS(url, callback) {
	var script = document.createElement('script'),
		fn = callback || function() {}
	script.type = 'text/javascript'
	//IE
	if (script.readyState) {
		script.onreadystatechange = function() {
			if (script.readyState == 'loaded' || script.readyState == 'complete') {
				script.onreadystatechange = null
				fn()
			}
		}
	} else {
		//其他浏览器
		script.onload = function() {
			fn()
		}
	}
	script.src = url
	document.getElementsByTagName('head')[0].appendChild(script)
}

// 四舍五入去浮点
function floatNumber(num, flo) {
	if(!flo) flo = 6
	if(typeof num === 'string') {
		num = parseFloat(num)
	}
	let newNumber = (num || 0).toFixed(flo)
	newNumber = parseFloat(newNumber)
	return newNumber
}
// 向上取整  向下取整Math.floor优惠金额直接去掉2位小数后的不四舍五入   向上取整：Math.ceil(that.dataRow.cost * 100)/100
function mathCeil(num, flo) {
	let newNumber = (num || 0).toFixed(6)
	newNumber = parseFloat(newNumber)
	let pow = Math.pow(10, flo)
	let result = parseFloat((newNumber * pow).toFixed(6))
	return Math.ceil(result) / pow
}
// 向下取整
function mathFloor(num, flo) {
	let newNumber = (num || 0).toFixed(6)
	newNumber = parseFloat(newNumber)
	let pow = Math.pow(10, flo)
	let result = parseFloat((newNumber * pow).toFixed(6))
	return Math.floor(result) / pow
}

function copyText(node) {
	if (!node) {
			return;
	}
	var result;
	// 将复制内容添加到临时textarea元素中
	var tempTextarea = document.createElement('textarea');
	document.body.appendChild(tempTextarea);
	if (typeof(node) == 'object') {
			// 复制节点中内容
			// 是否表单
			if (node.value) {
					tempTextarea.value = node.value;
			} else {
					tempTextarea.value = node.innerHTML;
			}
	} else {
			// 直接复制文本
			tempTextarea.value = node;
	}
	// 判断设备
	var u = navigator.userAgent;
	if (u.match(/(iPhone|iPod|iPad);?/i)) {
			// iOS
			// 移除已选择的元素
			window.getSelection().removeAllRanges();
			// 创建一个Range对象
			if(tempTextarea.createTextRange){
				var range = tempTextarea.createTextRange();
				range.collapse(true)
				range.moveStart('character',0);
				range.moveEnd('character',node.length);
				range.select();
			}else{
				tempTextarea.setSelectionRange(0, node.length);
				tempTextarea.focus();
			}

			// 选中
			// range.selectNode(tempTextarea);
			// // 执行选中元素
			// window.getSelection().addRange(range);
			// 复制
			result = document.execCommand('copy');
			// 移除选中元素
			window.getSelection().removeAllRanges();

	} else {
			// 选中    
			tempTextarea.select();
			// 复制
			result = document.execCommand('Copy');
	}
	// 移除临时文本域
	document.body.removeChild(tempTextarea);
	if (result) {
		uni.showToast({
			title: '单号已复制'
		})
	} else {
		uni.showToast({
			title: '复制失败'
		})
	}

	return result;
}

// 获取cookie
function getCookie(name) {
	var arr = null
	var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
	arr = document.cookie.match(reg)
	if (arr) {
		return (arr[2])
	} else {
		return null
	}
}

// 后台返回时间字符串显示-转/
const formatDateStrX = (dataStr,fomatStr) =>{
	let res = ''
	if(!fomatStr || typeof fomatStr === 'undefined'){
		fomatStr = 'yyyy-MM-dd hh:mm:ss'
	}
	if(dataStr && typeof dataStr === 'object'){
		res = formatDate(dataStr, fomatStr)
	}
	if(dataStr && typeof dataStr === 'number'){
		res = formatDate(new Date(dataStr), fomatStr)
	}
	if(dataStr && typeof dataStr === 'string'){
		res = formatDate(new Date(dataStr.replace(/-/g, '/').replace(/\./g, '/')), fomatStr)
	}
	return res
}
function getSelectOptionsLabel(options,value){
  let res = ''
  let selectIndex = options.findIndex(o => {
    return o.value === value
  })
  if (selectIndex >= 0) {
    res = options[selectIndex].label
  }
  return res
}

/**
 ** 加法函数，用来得到精确的加法结果
 ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
 ** 调用：accAdd(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
function accAdd(arg1, arg2) {
    let r1, r2, m
    try {
        r1 = arg1.toString().split('.')[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split('.')[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    return (arg1 * m + arg2 * m) / m
}

/**
 ** 减法函数，用来得到精确的减法结果
 ** 说明：javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的减法结果。
 ** 调用：accSub(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
function accSub(arg1, arg2) {
	var r1, r2, m, n;
	try {
	  r1 = arg1.toString().split(".")[1].length;
	} catch (e) {
	  r1 = 0;
	}
	try {
	  r2 = arg2.toString().split(".")[1].length;
	} catch (e) {
	  r2 = 0;
	}
	m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
	n = r1 >= r2 ? r1 : r2;
	return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

/**
 ** 乘法函数，用来得到精确的乘法结果
 ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
 ** 调用：accMul(arg1,arg2)
 ** 返回值：arg1乘以 arg2的精确结果
 **/
function accMul(arg1, arg2) {
    let m = 0
    let s1 = arg1.toString()
    let s2 = arg2.toString()
    try {
        m += s1.split('.')[1] ? s1.split('.')[1].length : ''
    } catch (e) {}
    try {
        m += s2.split('.')[1] ? s2.split('.')[1].length : ''
    } catch (e) {}
    return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m)
}

/**
 ** 除法函数，用来得到精确的除法结果
 ** 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
 ** 调用：accDiv(arg1,arg2)
 ** 返回值：arg1除以arg2的精确结果
 **/
function accDiv(arg1, arg2) {
    let t1 = 0
    let t2 = 0
    let r1
    let r2
    try {
        t1 = arg1.toString().split('.')[1].length
    } catch (e) {}
    try {
        t2 = arg2.toString().split('.')[1].length
    } catch (e) {}
    r1 = Number(arg1.toString().replace('.', ''))
    r2 = Number(arg2.toString().replace('.', ''))
    return (r1 / r2) * Math.pow(10, t2 - t1)
}

function dealIdCardNoStr(idStr) {
	let xStr = ''
	let xNumber = idStr.length - 6
	if(xNumber>0){
		for(var i = 0; i<xNumber;i++){
		xStr+= '*'
		}
	}
	return idStr.substring(0,3) +  xStr + idStr.substring(idStr.length-3, idStr.length)
}

/**
 * 计算与目标时间相差几天、几时、几分、几秒
 * @param diff
 * @returns {string}
 */
function calTime(diff) {
    var days = parseInt(diff / 1000 / 60 / 60 / 24);
    var hours = parseInt(diff / 1000 / 60 / 60) % 24;
    var mins = parseInt(diff / 1000 / 60) % 60;
    var seconds = parseInt(diff / 1000) % 60;
    return (days ?  (transFormat(days) + '天') : '') + transFormat(hours) + '小时' + transFormat(mins) + '分钟' + transFormat(seconds) + '秒';
}

/**
 * 补齐一位数字前面的0,使得输出美观
 * @param value
 * @returns {string}
 */
function transFormat(value) {
    return ('0' + value).slice(-2);
}

function dealSeatInfoListV3(data){
	let result = {
		...data,
		SubSeatInfoList:[],
		SubShowSeatInfoList:[],
	}
	// SeatAreaList
	if(data.SeatAreaList){
		let TicketMarkMap = {}
		for(var key in data.TicketMarkMap){
			TicketMarkMap[data.TicketMarkMap[key]] = key
		}
		data.SeatAreaList.forEach(sa=>{
			sa.SeatInfoList.forEach(si=>{
				let Status = 'xxx'
				const [No, X, Y, SeatNoIndex] = si.split('^')
				result.SubSeatInfoList.push({
					Floor_Id: '',
					Floor_Name: sa.F,
					Zone_x: Number(X || 0),
					Zone_y: Number(Y || 0),
					No: No,
					// Id: ele.Id,
					// Ticket_Id: ele.Tid,
					// id: ele.Sid,
					Global_Id: sa.A,
					Global_Name: sa.G,
					SeatNoIndex:Number(SeatNoIndex || 0),
				})
			})
			
		})
		result.SubSeatInfoList.sort((a,b)=>{
			return a.SeatNoIndex>b.SeatNoIndex ? 1: -1
		})
		data.StatusArr.forEach((Status,i)=>{
			let {Zone_x:X,Zone_y:Y} = result.SubSeatInfoList[i]
			let Tid = data.SeatTicketArr[i]
			// console.log('StatusArr========',Status,i,X,Y,Tid)
			if(Status === '1'){
				result.SubShowSeatInfoList.push({
					Ticket_Id: TicketMarkMap[Tid],
					Id: X+'_'+Y,
					Zone_x: Number(X || 0),
					Zone_y: Number(Y || 0),
					// Status: ele.status || 0,
					Status: 0,
				})
			}
		})
		
	}
	
	// console.log('t==result=========>',result)
	return result
}

function dealSeatInfoList(data){
	let result = {
		...data,
		SubSeatInfoList:[],
		SubShowSeatInfoList:[],
	}
	// SeatAreaList
	if(data.SeatAreaList){
		let TicketMarkMap = {}
		for(var key in data.TicketMarkMap){
			TicketMarkMap[data.TicketMarkMap[key]] = key
		}
		data.SeatAreaList.forEach(sa=>{
			sa.SeatInfoList.forEach(si=>{
				const [No, X, Y, Status,Tid] = si.split('^')
				result.SubSeatInfoList.push({
					Floor_Id: '',
					Floor_Name: sa.F,
					Zone_x: Number(X || 0),
					Zone_y: Number(Y || 0),
					No: No,
					// Id: ele.Id,
					// Ticket_Id: ele.Tid,
					// id: ele.Sid,
					Global_Id: sa.A,
					Global_Name: sa.G,
				})
				if(Status === '1'){
					result.SubShowSeatInfoList.push({
						Ticket_Id: TicketMarkMap[Tid],
						Id: X+'_'+Y,
						Zone_x: Number(X || 0),
						Zone_y: Number(Y || 0),
						// Status: ele.status || 0,
						Status: 0,
					})
				}
			})
			
		})
	}
	
	// console.log('t==result=========>',result)
	return result
}

function dealSubShowSeatInfoList(seatArr) {
	// return seatArr;
	return seatArr.map(ele => {
		return {
			Ticket_Id: ele.tid,
			Id: ele.id,
			Zone_x: ele.x,
			Zone_y: ele.y,
			// Status: ele.status || 0,
			Status: 0,
		}
	})
} 

function dealSubSeatInfoList(arr) {
	// 区块编号，座位名称，x坐标，y坐标，区域名称，楼层名称
	return arr.map(ele => {
		const [Gid, No, X, Y, G, F] = ele.split('&@')
		return {
			Floor_Id: '',
			Floor_Name: F,
			Zone_x: Number(X || 0),
			Zone_y: Number(Y || 0),
			No: No,
			// Id: ele.Id,
			// Ticket_Id: ele.Tid,
			// id: ele.Sid,
			Global_Id: Gid,
			Global_Name: G,
		}
	})
}

function changeFirstChar(originalObj={},type){
	return Object.keys(originalObj).reduce((acc, key) => {
		let value = originalObj[key];
		if (typeof value === 'object' && value !== null) {
		  if(value instanceof Array){
			// console.log('=key==========>',key,value)
		  } else {
			// 递归处理嵌套对象
			value = this.changeFirstChar(value);
		  }
		}
		// 将字符串的首字母大写
		key = type && type === 'upperCase' ? (key.charAt(0).toUpperCase()+ key.slice(1)) : (key.charAt(0).toLowerCase() + key.slice(1));
		acc[key] = value;
		return acc;
	}, {});
}

module.exports = {
	changeFirstChar,
	dealSeatInfoListV3,
	dealSeatInfoList,
	dealSubSeatInfoList,
	dealSubShowSeatInfoList,
	calTime,
	dealIdCardNoStr,
	accDiv,
	accMul,
	accSub,
	accAdd,
	getSelectOptionsLabel,
	formatDateStrX,
	getProgramEnv,
	getCookie,
	copyText,
	floatNumber,
	mathCeil,
	mathFloor,
	buildAvailableVideoUrl,
	abortAllRequest,
	isAllRequestOver,
	formatTime: formatTime,
	formatDate: formatDate,
	forWeek: forWeek,
	validateRules: validateRules, // 校验规则
	messageToast: messageToast, // 信息提醒
	commonShareAppMessage: commonShareAppMessage, // 分享
	commonViewTap: commonViewTap, // 跳转页面
	getPhoneNumberCodeString: getPhoneNumberCodeString, // 获取手机号****
	toThousands: toThousands, // 数字格式化 100,000,000.00
	getSystemInfoSync: getSystemInfoSync, // 获取客户端系统信息
	postData: postData, // ajax 请求
	postDataWV: postDataWV, //webview ajax请求
	postDataList: postDataList, // 列表ajax请求
	requestData: requestData,
	uploadImg: uploadImg, // 图片上传
	setPrePageData, // 返回上一页的时候可以调用将修改Page的data属性
	getPrePage,
	viewMapAddress: viewMapAddress, // 在地图上查看位置
	sectionToChinese: sectionToChinese, // 数字变汉字
	dealRelativeUrl: dealRelativeUrl, // 处理相对路径url问题
	checkAndForceUpdate: checkAndForceUpdate,
	detectionUpdata: detectionUpdata, //更新版本
	judgeTouchDirection: judgeTouchDirection, // touch方向
	arrUniq: arrUniq, // 数组去重
	cryptoParamObject: cryptoParamObject, // 加密请求参数对象
	cryptoParamValues: cryptoParamValues, // 加密请求参数键值
	changeTime: changeTime,
	getboundingClientRect: getboundingClientRect,
	formatDateTime: formatDateTime,
	addZero: addZero,
	transWeekDay: transWeekDay,
	domWatch: domWatch,
	isWeiXin: isWeiXin, // 是否是微信内置浏览器
	getQueryStringByName: getQueryStringByName, // 取url参数
	loadJS: loadJS, // 动态加载js
	cpObject: cpObject // 拷贝对象属性和原型
}
